import myAxios from "@/plugins/axios";


const userService = {

    setAsBuyer(userId) {
        return myAxios.privateInstance
            .post(`/user/${userId}/set-buyer`).then(resp => {
                return resp
            })
            .catch(error => {
                throw new Error(error);
            })
    },
    async load(user) {
        return myAxios.privateInstance
            .get(`/user?email=${user.email || ""}`)
            .catch(error => {
                throw new Error(error);
            });
    },
    async loadInternal(user) {
        return myAxios.privateInstance
            .get(`/internal-user?email=${user.email || ""}`)
            .catch(error => {
                throw new Error(error);
            });
    }
}

export default userService